import './App.css';
import Panel from './Panel';

function App() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });

    // Close mobile menu after clicking
    const navLinks = document.querySelector('.nav-links');
    navLinks?.classList.remove('active');
  };

  const toggleMenu = () => {
    const navLinks = document.querySelector('.nav-links');
    navLinks?.classList.toggle('active');
  };

  return (
    <div className="App">
      {/* Navbar */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo"><strong>Supper Club LA</strong></div>
          <div className="hamburger" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul className="nav-links">
            <span className="close-menu" onClick={toggleMenu}>×</span>
            <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a></li>
            <li><a href="#pictures" onClick={(e) => { e.preventDefault(); scrollToSection('pictures'); }}>Gallery</a></li>
            <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Panel */}
      <Panel className="hero-panel">
        <div className="hero-content">
          <div className="hero-text">
            <h1>We make great food so people can enjoy <span className="highlight">unforgettable</span> meals.</h1>
            <p>Bringing together communities through food</p>
          </div>
          <div className="hero-image"></div>
        </div>
      </Panel>

      {/* About Panel */}
      <Panel id="about" className="about-panel">
        <h2 className="section-title">About Us</h2>
        <div className="about-content">
          <div className="about-image-left"></div>
          <div className="about-text">
            <p>
              We're originally from the San Fernando Valley, where we discovered our passion for connecting people through communities. We believe that connection is the foundation for everything meaningful—sharing laughs, learning from others, creating lasting memories, and building relationships that extend beyond the dinner table.
            </p>
            <p>
              Our supper club brings together people from all walks of life to experience the simple joy of breaking bread together. Each dinner is thoughtfully crafted to foster genuine conversation and create an atmosphere where strangers become friends. We source fresh, seasonal ingredients and prepare dishes that celebrate both tradition and creativity.
            </p>
            <p>
              What started as intimate gatherings in our home has grown into a vibrant community of food lovers, storytellers, and connection seekers. We're honored to create spaces where people can slow down, savor great food, and build the kinds of connections that make life richer.
            </p>
          </div>
        </div>
        <div className="team-section">
          <div className="team-member">
            <div className="team-image"></div>
            <h3>Raphael Fontejon</h3>
            <p>Chef</p>
            <p className="credential">Culinary Institute of America</p>
          </div>
          <div className="team-member">
            <div className="team-image"></div>
            <h3>Kelsi Bergesen</h3>
            <p>Baker</p>
            <p className="credential">Culinary Institute of America</p>
          </div>
          <div className="team-member">
            <div className="team-image"></div>
            <h3>Rex Ordonez</h3>
            <p>Host & Operations</p>
            <p className="credential">University of Southern California</p>
          </div>
        </div>
      </Panel>

      {/* Pictures Panel */}
      <Panel id="pictures" className="pictures-panel">
        <h2 className="section-title">Our Gallery</h2>
        <div className="gallery">
          <div className="gallery-item"></div>
          <div className="gallery-item"></div>
          <div className="gallery-item"></div>
          <div className="gallery-item"></div>
          <div className="gallery-item"></div>
          <div className="gallery-item"></div>
        </div>
      </Panel>

      {/* Contact Panel */}
      <Panel id="contact" className="contact-panel">
        <h2 className="section-title">Contact Us</h2>
        <div className="contact-content">
          <form className="contact-form">
            <input
              type="email"
              placeholder="Your Email"
              className="contact-input"
              required
            />
            <textarea
              placeholder="Your Message"
              className="contact-textarea"
              rows="6"
              required
            ></textarea>
            <button type="submit" className="contact-button">Send Message</button>
          </form>
        </div>
      </Panel>
    </div>
  );
}

export default App;
